<template>
  <div>
    <div><p class="pstyle" >先上传文件再上传版本信息</p></div>
    <br>
    <br>
    <br>
    <el-form ref="formData" :model="formData" :rules="rules" label-position="right" label-width="100px">

      <el-row>
        <el-col :span="15">
          <el-form-item label="文件上传" >
            <WifiApks @btndisable="changebtndisable">
            </WifiApks>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="15">
          <el-form-item label="文件id" prop="fileId">
            <el-input v-model="formData.fileId" placeholder="文件上传返回的id"/>
          </el-form-item>
        </el-col>
      </el-row>


      <el-row>
        <el-col :span="15">
          <el-form-item label="版本号" prop="versionCode">
            <el-input v-model="formData.versionCode" placeholder="example：1"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="15">
          <el-form-item label="版本名" prop="versionName">
            <el-input v-model="formData.versionName" placeholder="example：1.1.1"/>
          </el-form-item>
        </el-col>
      </el-row>


      <el-row>
      <el-col :span="15">
        <el-form-item label="更新描述" prop="updateContent">
          <el-input v-model="formData.updateContent"/>
        </el-form-item>
      </el-col>
    </el-row>


      <el-row>
        <el-col :span="15">
          <el-form-item label="状态" prop="status" >
            <el-input v-model="formData.status" placeholder="0为禁用 1为正常"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="15">
          <el-form-item label="类型" prop="type" >
            <el-input v-model="formData.type" placeholder="0 不强制更新 1 hasAffectCodes拥有字段强制更新 2 所有版本强制更新"/>
          </el-form-item>
        </el-col>
      </el-row>

<!--      <el-row>-->
<!--        <el-col :span="15">-->
<!--          <el-form-item label="createUser" prop="createUser">-->
<!--            <el-input v-model="formData.createUser"/>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
<!--      </el-row>-->

    </el-form>

      <el-button type="primary" @click="handleAdd('formData')" :disabled="btndisable" >确定上传</el-button>

  </div>
</template>

<script>
import axios from "@/wifiaxios";
import WifiApks from "@/views/sys/WifiApks";



export default {
  name: "AppVersion",
  components: {WifiApks},
  data() {
    return {
      formData: {
        fileId: "",
        versionCode: "",
        versionName: "",
        updateContent: "",
        status: "",
        type: "",
      },
      rules: {
        fileId: [{ required: true, message: '文件id为必填项', trigger: 'blur' }],
        versionCode: [{ required: true, message: '版本号为必填项', trigger: 'blur' }],
        versionName: [{ required: true, message: '版本名为必填项', trigger: 'blur' }],
      },
      btndisable:true
    }
  },
  created(){
  },
  methods: {


    handleAdd(VersionName) {

      this.$refs[VersionName].validate((valid) => {
        if(valid){
          axios.post("/sys/app/version/save", this.formData).then((res) => {
            this.$message.success(res.data.msg);
          })
        }
      })
    },
    changebtndisable(btndisable){
      this.btndisable = btndisable
    }

  }

}

</script>

<style scoped>
.el-button{
  width: 150px;
}
.pstyle{
  float: left;
  color: red;
}
</style>
